var globalTimeoutId;
export var validateInputValues = (fields, formData, currentPlatform) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  var isValid = false;
  var _loop = function _loop() {
      var item = fields[i];
      var hiddenField = (_a = item === null || item === void 0 ? void 0 : item.hideOnPlatform) === null || _a === void 0 ? void 0 : _a.includes(currentPlatform);
      if (!hiddenField && item.fieldType === 'INPUT') {
        var fieldStateError = ((_b = item === null || item === void 0 ? void 0 : item.fieldData) === null || _b === void 0 ? void 0 : _b.state) === 'error';
        var isFieldLoading = ((_c = item === null || item === void 0 ? void 0 : item.fieldData) === null || _c === void 0 ? void 0 : _c.showLoader) === true;
        var validationRegex = (_d = item === null || item === void 0 ? void 0 : item.fieldData) === null || _d === void 0 ? void 0 : _d.validationRegex;
        var validationRegexFlag = (_f = (_e = item === null || item === void 0 ? void 0 : item.fieldData) === null || _e === void 0 ? void 0 : _e.validationRegexFlag) !== null && _f !== void 0 ? _f : undefined;
        if (typeof validationRegex === 'string') {
          var value = "" + ((_g = formData[item === null || item === void 0 ? void 0 : item.fieldId]) !== null && _g !== void 0 ? _g : '');
          var validInput = value === null || value === void 0 ? void 0 : value.match(new RegExp(validationRegex, validationRegexFlag));
          if (validInput && (validInput === null || validInput === void 0 ? void 0 : validInput.length) > 0 && !fieldStateError && !isFieldLoading) {
            isValid = true;
          } else {
            isValid = false;
            return 0;
          }
        } else if (!validationRegexFlag && (item === null || item === void 0 ? void 0 : item.required)) {
          var _value = formData[item === null || item === void 0 ? void 0 : item.fieldId];
          if ((_value === null || _value === void 0 ? void 0 : _value.length) > 0) {
            isValid = true;
          } else {
            isValid = false;
            return 0;
          }
        } else if (fieldStateError) {
          isValid = false;
        } else if (isFieldLoading) {
          isValid = false;
        } else {
          isValid = true;
        }
      } else if (!hiddenField && item.fieldType === 'RADIO') {
        var isRadioSelected = (_j = (_h = item === null || item === void 0 ? void 0 : item.fieldData) === null || _h === void 0 ? void 0 : _h.radioButtons) === null || _j === void 0 ? void 0 : _j.some(_radioItem => (_radioItem === null || _radioItem === void 0 ? void 0 : _radioItem.id) === formData[item === null || item === void 0 ? void 0 : item.fieldId]);
        isValid = isRadioSelected;
        if (!isValid && (item === null || item === void 0 ? void 0 : item.required)) {
          isValid = false;
          return 0;
        }
      } else if (!hiddenField && item.fieldType === 'CHECKBOX' && item.required) {
        if (((_k = formData === null || formData === void 0 ? void 0 : formData.checkbox) === null || _k === void 0 ? void 0 : _k.length) > 0) {
          isValid = true;
        } else {
          isValid = false;
          return 0;
        }
      } else if (!hiddenField && item.fieldType === 'DROPDOWN' && ((item === null || item === void 0 ? void 0 : item.required) === true || 'required' in item === false)) {
        if (((_l = formData[item === null || item === void 0 ? void 0 : item.fieldId]) === null || _l === void 0 ? void 0 : _l.length) > 0) {
          isValid = true;
        } else {
          isValid = false;
          return 0;
        }
      } else if (!hiddenField && item.fieldType === 'DATE' && (item === null || item === void 0 ? void 0 : item.required) === true) {
        if (formData[item === null || item === void 0 ? void 0 : item.fieldId]) {
          isValid = true;
        } else {
          isValid = false;
          return 0;
        }
      }
    },
    _ret;
  for (var i = 0; i < (fields === null || fields === void 0 ? void 0 : fields.length); i++) {
    _ret = _loop();
    if (_ret === 0) break;
  }
  return isValid;
};
export function globalDebounce(func, delay) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (globalTimeoutId) {
      clearTimeout(globalTimeoutId);
    }
    globalTimeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
export var clearTimeoutMethod = () => {
  if (globalTimeoutId) {
    clearTimeout(globalTimeoutId);
  }
};